/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-12 13:33:57
 * @LastEditTime : 2024-01-23 09:59:37
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb1\src\api\GHnumber\weightTask.js
 */
import request from '@/utils/request'
export const queryPage1 = '/icps/system/sign/dataCollection/stationWeightTask/queryWeightTask'
export const queryPage2 = '/icps/system/sign/dataCollection/stationWeightTask/queryUnatendedWeightTask'
/*删除售料任务*/
export function deleteTask(params) {
    return request({
        url: '/icps/system/sign/dataCollection/returnGood/deleteTask',
        method: 'GET',
        params
    })
}
/*打印详情获取*/
export function printTicket(data) {
    return request({
        url: '/icps/system/sign/dataCollection/stationWeightTask/printTicket',
        method: 'post',
        data
    })
} 
/*获取库存仓*/
export function queryWarehouseList(data) {
    return request({
        url: '/icps/system/sign/basics/inventory/queryWarehouseList',
        method: 'post',
        data
    })
} 
/*推送无人值守*/
export function sendDataToUnatendedWeight(data) {
    return request({
        url: '/icps/system/sign/dataCollection/stationWeightTask/sendDataToUnatendedWeight',
        method: 'post',
        data
    })
} 
/*推送无人值守*/
export function updateWeightTask(data) {
    return request({
        url: '/icps/system/sign/dataCollection/stationWeightTask/updateWeightTask',
        method: 'post',
        data
    })
} 
/*获取补单数据*/
export function queryRepairTaskPage(data) {
    return request({
        url: '/icps/system/sign/dataCollection/stationWeightTask/queryRepairTaskPage',
        method: 'post',
        data
    })
} 
//关联
export function associatedWeightTask(data) {
    return request({
        url: '/icps/system/sign/dataCollection/stationWeightTask/associatedWeightTask',
        method: 'post',
        data
    })
} 
//判断是否自动关联
export function automaticAssociation(data) {
    return request({
        url: '/icps/system/sign/dataCollection/stationWeightTask/automaticAssociation',
        method: 'post',
        data
    })
} 
